<section>
  <header>
    <h2 data-testid="av-check-heading-main">Camera and Audio</h2>
  </header>
  <app-audio-video-check (continueButtonClicked)="continueCheckIn()"></app-audio-video-check>
</section>
<app-package-status-monitor />